/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { LinearProgress } from "@material-ui/core";
import axios from "axios";
import Moment from "moment";
import React, { Component } from "react";
import { Card, Modal } from "react-bootstrap";
import { NoticeInformasi } from "../../../_metronic/_partials/controls";
import AppConfig from "../../config/AppConfig";

class Informasi extends Component {
  constructor(props, context) {
    super(props, context);
    this.modalDetail = this.modalDetail.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  state = {
    sessiondata: JSON.parse(localStorage.getItem("sessiondata")),
    userdata: JSON.parse(localStorage.getItem("userdata")),
    loadingList: true,
    loadingDetails: true,
    modalDetail: false,
    data_konten: [],
    data_foto: [],
    data_lampiran: [],
    detail_informasi: [],
    detail_cover: null,
    file: "",
    nm_file: "",
    // paging
    keyword: "",
    totalData: 0,
    totalPaginationNumber: 0,
    limit: 10,
    start: 0,
    currentPage: 1,
    pageLimit: 5,
    showFrom: 0,
  };

  modalDetail(id, cover) {
    this.setState({ modalDetail: true, loadingDetails: true, detail_cover: cover });
    axios
      .get(AppConfig.EditInformasi + id)
      .then((res) => {
        this.setState({
          loadingDetails: false,
          detail_informasi: {
            judul: res.data.result.data_konten.judul,
            isi_konten: res.data.result.data_konten.isi_konten,
          },
          file: res.data.result.data_lampiran?.konten_dokumen,
          nm_file: res.data.result.data_lampiran?.filename,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    this.setState({ loadingList: true });

    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    formData.append("data[id_viewer]", this.state.sessiondata.i_idrole);
    formData.append("data[id_pembina]", this.state.sessiondata.i_idunit);
    axios
      .post(
        AppConfig.ListKonten +
          "?limit=" +
          this.state.limit +
          "&start=" +
          this.state.start,
        formData
      )
      .then((res) => {
        this.setState(
          {
            loadingList: false,
            data_konten: res.data.result.data,
            data_foto: res.data.result.pict_cover,
            totalData: res.data.result.total_rows,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_rows / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          },
          () => {
            // console.log(this.state.getUsers);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleClose() {
    this.setState({
      modalDetail: false,
      detail_cover: null,
    });
  }

  downloadPDF(file) {
    const linkSource = `data:application/pdf;base64,${file}`;
    const downloadLink = document.createElement("a");
    const fileName = this.state.nm_file;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  // Layout ============================================================================
  render() {
    let id_pembina = this.state.sessiondata.i_idunit;
    let arrOfKonten = [];
    let coverPict = [];
    console.log(this.state.sessiondata);
    for (let i = 0; i < this.state.data_konten.length; i++) {
      const el = this.state.data_konten[i];
      if (el.id_role_updater === 10) {
        arrOfKonten.push(el);
        coverPict.push(this.state.data_foto[i]);
      }
      if (el.id_role_updater === 2014) {
        if (el.id_pembina === id_pembina) {
          arrOfKonten.push(el);
          coverPict.push(this.state.data_foto[i]);
        }
      }
    }

    return (
      <>
        <style>{`
          .card-informasi {
            cursor: pointer;
            transition: transform 0.25s ease, box-shadow 0.25s ease;
          }
          .card-informasi:hover {
            transform: translateY(-6px);
            box-shadow: 0 12px 24px rgba(0,0,0,0.12) !important;
          }
        `}</style>
        <NoticeInformasi style={{ marginBottom: "0px", boxShadow: "none" }}>
          <strong style={{ fontSize: "18px" }}>Informasi</strong>
          <p>Informasi lain</p>
        </NoticeInformasi>
        <br />

        <div className="row mt-4">
          {this.state.loadingList === true ? (
            <div className="col-12">
              <Card>
                <Card.Body>
                  <LinearProgress color="secondary" variant="query" />
                </Card.Body>
              </Card>
            </div>
          ) : arrOfKonten.length > 0 ? (
            arrOfKonten.map((data, idx) => (
              <div
                key={data.id_konten}
                className="col-sm-6 col-md-4 col-lg-3 mb-4"
              >
                <Card
                  className="h-100 shadow-sm card-informasi"
                  onClick={() => this.modalDetail(data.id_konten, coverPict[idx])}
                >
                  <div
                    style={{
                      height: "200px",
                      overflow: "hidden",
                      backgroundColor: "#f8f9fa",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {coverPict[idx] ? (
                      <Card.Img
                        variant="top"
                        src={`data:image/jpeg;base64,${coverPict[idx]}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <img
                        src="media\logos\logo-letter-2.png"
                        alt="placeholder"
                        style={{
                          maxHeight: "120px",
                          maxWidth: "120px",
                          opacity: 0.5,
                        }}
                      />
                    )}
                  </div>
                  <Card.Body className="d-flex flex-column">
                    <Card.Title
                      className="font-weight-bold text-dark"
                      style={{
                        fontSize: "1rem",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {data.judul}
                    </Card.Title>
                    <Card.Text
                      className="text-dark-50"
                      style={{
                        fontSize: "0.875rem",
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        flex: "1 0 auto",
                      }}
                    >
                      {data.deskripsi}
                    </Card.Text>
                    <div className="text-muted" style={{ fontSize: "0.8rem" }}>
                      <i className="flaticon-user mr-1" />
                      {data.nm_role_updater}
                      <br />
                      <i className="flaticon-calendar mr-1" />
                      {Moment(data.updated_at).format("DD-MMMM-YYYY")}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))
          ) : (
            <div className="col-12">
              <Card>
                <Card.Body>
                  <em className="text-muted">Belum ada informasi tersedia</em>
                </Card.Body>
              </Card>
            </div>
          )}
        </div>

        {/*========================================== Begin Modal Detail ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalDetail}
          onHide={this.handleClose}
          keyboard={true}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              {this.state.loadingDetails
                ? "Memuat..."
                : this.state.detail_informasi.judul}
            </Modal.Title>
            <button
              type="button"
              className="close"
              onClick={this.handleClose}
              style={{ outline: "none" }}
            >
              <i className="flaticon2-cross" />
            </button>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <LinearProgress color="secondary" variant="query" />
            ) : (
              <>
                {this.state.detail_cover && (
                  <div
                    className="text-center mb-4"
                    style={{
                      maxHeight: "300px",
                      overflow: "hidden",
                      borderRadius: "6px",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    <img
                      src={`data:image/jpeg;base64,${this.state.detail_cover}`}
                      alt="cover"
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "300px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                )}
                <div
                  className="text-justify"
                  style={{ lineHeight: 1.8 }}
                  dangerouslySetInnerHTML={{
                    __html: this.state.detail_informasi.isi_konten,
                  }}
                />
                <hr />
                <div>
                  <strong>Lampiran :</strong>{" "}
                  {this.state.nm_file === undefined ? (
                    <i style={{ fontSize: "13px" }}>Tidak ada lampiran</i>
                  ) : (
                    <a
                      href="#"
                      onClick={() => this.downloadPDF(this.state.file)}
                      style={{ fontWeight: 500 }}
                    >
                      <i className="flaticon2-pdf-file mr-1" />
                      {this.state.nm_file}
                    </a>
                  )}
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
        {/*========================================== End Modal Detail ========================================== */}
      </>
    );
  }
}
export default Informasi;
